/**
 * Event shipping_details_clicked
 * ---
 * Notify Statsig when the `shipping details` button on PDP is clicked
 */

function run() {
  const buttonShippingDetails = document.querySelector(
    "[data-shipping-details] button"
  );

  if (!buttonShippingDetails) {
    return;
  }

  const client = window.Statsig.instance();

  buttonShippingDetails.addEventListener("click", function (event) {
    client.logEvent("shipping_details_clicked");
  });
}

if (window?.Statsig?.instance()?.loadingStatus === "Ready") {
  run();
} else {
  window.addEventListener("statsigReady", run);
}
